import { Script } from 'gatsby'
import React from 'react'
import { useSiteSettings } from '../../hooks/useSiteSettings'
import { isNullOrWhiteSpace } from '../../utilities/string'

export const GtmScript = () => {
  const siteSettings = useSiteSettings()

  const gtmId = siteSettings?.gtmId ?? process.env.GATSBY_GOOGLE_TAG_MANAGER_ID

  return !isNullOrWhiteSpace(gtmId) && process.env.NODE_ENV === 'production' ? (
    <Script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`}</Script>
  ) : null
}
